export const MAIN_TITLE = "Nepal Injury Research Centre (NIRC)";
export const BASE_TITLE = "NIRC | ";
